// extra url
// const Base_URL = `https://Nestfinlive.bizclockinfotech.com:8989`
// const BASE_URL_HRM = 'https://ihfc.candidate.physus.org:8989';
const BASE_URL_HRM = "https://weconnect.bizclockinfotech.com:3589";

// local url

// const Nestfin_Base_Url = `http://192.168.1.9:34340/api/superadmin/v1`

// Local Server url  ***********************************************************************

// const Base_URL = "http://192.168.1.21:34340/api";
const Base_URL = "https://cloud.nestfin.app/api";

// LIVE SERVER URL ***********************************************************************

// const Base_URL = `https://nestfin.app:8443/api`;
const Nestfin_Base_Url = `https://nestfin.app:8443/api/superadmin/v1`;
const Base_URL_NF2 = `https://nestfin.app:8443/api/nf`;

// edit live server end

export const webServiceUrl = {
  // login: `${Admin_Base_URL}/auth/login`,
  login: `${BASE_URL_HRM}/login`,
  SEND_OTP: `${Base_URL}/v1/send-otp`,
  VERIFY_OTP: `${Base_URL}/v1/verify-otp`,

  // organization details
  GET_ALL_PROPERTY: `${Base_URL}/org/v1/getall-org-property`,
  GET_ORG_PROPERTY: `${Base_URL}/staff/v1/get-org-staff`,
  GET_ORG_ADMINSTAFF: `${Base_URL}/staff/v1/get-org-staff`,
  GET_ALL_PROPERTY_TANANT: `${Base_URL}/tanant/v1/property-tanant-get-all`,
  VIEW_ORG_STAFF: `${Base_URL}/staff/v1/view-org-staff`,
  VIEW_ALL_ADMIN: `${Base_URL}/staff/v1/view-org-staff`,
  VIEW_STAFF_ROLES: `${Base_URL}/staff/v1/view-staff-roles`,

  // LEAD-DASHBOARD
  // start =========================================
  ALL_LEAD_LIST: `${Base_URL}/leads_3p/v1/all-leads-list`,
  COUNT_LEAD_HISTORY: `${Base_URL}/leads_3p/v1/count-leads-history`,
  PIPELINE_COUNT_LEADS_HISTORY: `${Base_URL}/leads_3p/v1/pipeline-count-leads-history`,
  LOST_LEAD_REASON: `${Base_URL}/leads_3p/v1/lost-lead-reason`,
  LEAD_BOOKING_RECONCILIATION: `${Base_URL}/leads_3p/v1/leads-booking-reconciliation`,
  VERIFY_LEADS_BOOKING: `${Base_URL}/leads_3p/v1/verify-leads-booking`,
  FOLLOWUPTRAILS: `${Base_URL}/leads_3p/v1/get-leads-trails`,
  DOWNLOAD_EXCEL_TEMPLATE: `${Base_URL}/leads_3p/v1/download-excel-template`,
  DOWNLOAD_SAMPLE_TEMPLATE: `${Base_URL}/leads_3p/v1/download-sample-excel-template`,
  UPLOAD_FILE: `${Base_URL}/leads_3p/v1/upload-lead-excel`,
  SALES_TEAM: `${Base_URL}/leads_3p/v1/staff-list`,
  SALES_LEAD_LIST: `${Base_URL}/leads_3p/v1/staff-lead-list`,
  RECENT_FOLLOWUP_TRAILS: `${Base_URL}/leads_3p/v1/recent-followup-trails`,
  LEAD_SOURCE_COUNT: `${Base_URL}/leads_3p/v1/lead-source-count`,
  REVENUE_INCOME: `${Base_URL}/leads_3p/v1/monthly-income-per-year`,
  VIEW_STAFF_RECENT_ACTIVITIES: `${Base_URL}/leads_3p/v1/staff-recent-activity`,

  // end ================================================

  // Main Nestfin api
  FETCH_ALL_ORGANISATION: `${Nestfin_Base_Url}/fetch-all-org`,
  FETCH_PROPERTY_Detail: `${Nestfin_Base_Url}/fetch-property`,
  GET_ORG_STAFF: `${Nestfin_Base_Url}/fetch-view-staff`,
  GET_Prop_STRUCTURE: `${Nestfin_Base_Url}/view-stracture`,
  GET_PROPERTY_FEATURES: `${Nestfin_Base_Url}/view-property-features`,
  GET_PROPERTY_TENANTS: `${Nestfin_Base_Url}/view-property-tenants`,
  GET_PROPERTY_PHOTO: `${Nestfin_Base_Url}/fetch-property-photo`,
  VIEW_BOOKING: `${Nestfin_Base_Url}/view-booking`,
  GET_LEAD_ACCOUNT_PROFILE: `${Nestfin_Base_Url}/lead-account-profile`,
  UPDATE_ORGANIZATION: ``,
  // End Main Nestfin api

  // Nestfin my api's
  GET_ORGANISATION: `${Base_URL_NF2}/get-organisation`,
  GET_ORGANISATION_PROPERTIES: `${Base_URL_NF2}/get-organisation-property`,
  GET_LEAD_ACCOUNT_PROFILE: `${Base_URL_NF2}/get-lead-account-profile`,
  GET_LEAD_ACCOUNT_ACTIVITY: `${Base_URL_NF2}/get-lead-account-activity`,
  GET_TENANT_BOOKING: `${Base_URL_NF2}/get-tenant-booking`,
  GET_TICKET: `${Base_URL_NF2}/get-ticket`,
  GET_TICKET_ATTACHMENT: `${Base_URL_NF2}/get-ticket-attachment`,
  // Nestfin my api's

  //Group Api
  CREATE_GROUPS: `${Base_URL}/sales/v1/create-group`,
  EDIT_GROUPS: `${Base_URL}/sales/v1/edit-group`,
  VIEW_GROUPS: `${Base_URL}/sales/v1/view-group`,
  VIEW_GROUP_TEAMS: `${Base_URL}/sales/v1/view-group-teams`,
  VIEW_LEAD_LIST: `${Base_URL}sales/v1/view-group-leads-list`,
  VIEW_LEAD_LIST: `${Base_URL}/sales/v1/view-group-leads-list`,
  UPLOAD_BULK_LEADS: `${Base_URL}/sales/v1/upload-bulk-leads1`,
};
